export default __webpack_public_path__ + "static/media/defaultUser.d62cd592.jpg";